import { gql } from '@apollo/client';

export const VideoFragment = gql`
  fragment Video on Video {
    _id
    id: _id
    name
    processed
    thumbUrl
    type
    sources {
      size
      src
      type
    }
  }
`;
